import React, { ReactNode } from 'react';

import { BlockLabel, CenterBlock, SettingsBlockWrapper } from './style';

type Props = {
  children: ReactNode;
  withBorder?: boolean;
  label?: ReactNode;
};

export const SettingsBlock = ({ children, label, withBorder }: Props): JSX.Element => {
  return (
    <SettingsBlockWrapper withBorder={!!withBorder}>
      <BlockLabel>{label}</BlockLabel>
      <CenterBlock>{children}</CenterBlock>
    </SettingsBlockWrapper>
  );
};
